import {
  updateRadioMode as setRadioMode,
  updateCurrentRadio as update,
  updateIsHD as updateHD,
} from './slice';
import { AppThunk } from '../../../app/store';
import { StreamModel } from '../../../models';
import {
  updateCurrentEpisode,
  updatePlayerRate,
} from '../../currentpodcast/store/actions';
import { podcastEpisodeInitialState } from '../../currentpodcast/store/slice';

export const updateCurrentRadio =
  (stream: StreamModel): AppThunk =>
  dispatch => {
    dispatch(update(stream));
  };

export const updateIsHD =
  (isHD: boolean): AppThunk =>
  dispatch => {
    dispatch(updateHD(isHD));
  };

export const updateRadioMode =
  (isActive: boolean): AppThunk =>
  dispatch => {
    dispatch(setRadioMode(isActive));
    if (isActive) {
      dispatch(updatePlayerRate(1));
      dispatch(updateCurrentEpisode(podcastEpisodeInitialState));
    }
  };
